import React, { Component } from "react";
import { Input, Divider, Button, Form, Spin, message, Row, Col } from "antd";
import { UserOutlined, LockOutlined, SyncOutlined } from "@ant-design/icons";
import "../assets/stylus/login.styl";
// redux
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { setLocaleConfig } from "@/state/action/comAction";

// 国际化
import {
  loginWithPasswordApi,
  getCompanyListApi,
  refreshTokenApi,
  getCode,
  ssoLogin,
} from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import ddLogin from "../utils/ddLogin";

const AUTO_SELECT_COMPANY = true;
const ShowSwitchLoginType = false; // 做了钉钉登陆的功能，暂时隐藏

@connect((state) => state, { setLocaleConfig })
class Login extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.lang = this.props.appLocalInfo.locale;

    let language = null;
    if (this.props.intl.locale === "zh") {
      language = "中文";
    } else if (this.props.intl.locale === "en") {
      language = "英文";
    } else if (this.props.intl.locale === "es") {
      language = "西班牙语";
    }
    this.state = {
      language: language,
      loginType: "password", // dingding,password
      logining: false,
      imgSrc: "",
      requestId: "",
      clientId: "cams-omc",
      authUrl: null,
    };
    this.interval = null;
    this.getCode();
    this.refreshCode();
  }

  // 国际化-切换语言

  changeLocale = (lang) => {
    if (lang === "zh") {
      this.setState({
        language: "中文",
      });
      this.props.setLocaleConfig("zh");
      window.sessionStorage.setItem("locale", "zh");
    } else if (lang === "en") {
      this.setState({
        language: "英文",
      });
      this.props.setLocaleConfig("en");
      window.sessionStorage.setItem("locale", "zh");
    } else if (lang === "es") {
      this.setState({
        language: "西班牙语",
      });
      this.props.setLocaleConfig("es");
      window.sessionStorage.setItem("locale", "es");
    }
  };

  // redux
  mapStateToProps = (state) => {
    return {
      prop: state.prop,
    };
  };

  componentDidMount() {
    // this.appid = process.env.doingType === 'buildPro'
    // ? 'dingoazuo5qvl71g8x5p1q' : 'dingoa3delr2571zpjcvai';
    this.appid = process.env.REACT_APP_LOGIN_APPID;
    // https://oms-console.starcharge.com/login.do 外网
    // http://lijiang.test.ccchong.com:8081/login.do 内网
    // this.REDIRECT_URL = process.env.doingType === 'buildPro' ? 'https://oms-console.starcharge.com/login.do' : 'http://oms.api.test.ccchong.com:8086/login.do';
    this.REDIRECT_URL = process.env.REACT_APP_LOGIN_REDIRECT_URL;
    // const gotoUrl = encodeURIComponent(
    //   `https://oapi.dingtalk.com/connect/qrconnect?appid=${this.appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${this.REDIRECT_URL}`,
    // );
    // ddLogin.init({
    //   id: "login_container", // 这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
    //   goto: gotoUrl,
    //   style: "border:none;background-color:transparent;",
    //   width: "300",
    //   height: "300",
    // });
    let base = window.location.href.split("#")[0];
    if (base.endsWith("index.html")) {
      // 去掉结尾的index.html
      base = base.substring(0, base.length - 10);
    }
    const redirectUri = encodeURIComponent(
      base + `${base.endsWith("/") ? "auth-callback.html" : "/auth-callback.html"}`,
    );
    const authUrl =
      process.env.REACT_APP_SSO_URL +
      `/realms/cams/protocol/openid-connect/auth?response_type=code&client_id=${this.state.clientId}&redirect_uri=${redirectUri}&scope=openid profile`;
    this.state.authUrl = authUrl;
    window.sessionStorage.setItem("base", base);
    window.sessionStorage.setItem("redirectUrl", redirectUri);
    window.sessionStorage.setItem("authUrl", authUrl);

    this.init();
    window.sessionStorage.removeItem("token");
    window.sessionStorage.removeItem("name");
    window.sessionStorage.removeItem("omc-token");
    window.sessionStorage.removeItem("omc-username");
    if (window.sessionStorage.getItem("sso_code")) {
      console.log("sso_code:", window.sessionStorage.getItem("sso_code"));
      this.setState({ logining: true });
      //SSO-Login
      this.handleSSOLogin(window.sessionStorage.getItem("sso_code"));
    }
  }

  init() {
    // if (typeof window.addEventListener !== "undefined") {
    //   window.addEventListener("message", this.hanndleMessage, false);
    // } else if (typeof window.attachEvent !== "undefined") {
    //   window.attachEvent("onmessage", this.hanndleMessage);
    // }
    window.requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame;

    // let canvas = document.getElementById('canvas');
    // let ctx = canvas.getContext('2d');
    // let w = canvas.width = canvas.offsetWidth;
    // let h = canvas.height = canvas.offsetHeight;
    // let circles = [];
    // let current_circle = new currentCirle(0, 0)

    // let draw = function () {
    //     ctx.clearRect(0, 0, w, h);
    //     for (let i = 0; i < circles.length; i++) {
    //         circles[i].move(w, h);
    //         circles[i].drawCircle(ctx);
    //         for (let j = i + 1; j < circles.length; j++) {
    //             circles[i].drawLine(ctx, circles[j])
    //         }
    //     }
    //     if (current_circle.x) {
    //         current_circle.drawCircle(ctx);
    //         for (var k = 1; k < circles.length; k++) {
    //             current_circle.drawLine(ctx, circles[k])
    //         }
    //     }
    //     requestAnimationFrame(draw)
    // }

    // let init2 = function (num) {
    //     for (var i = 0; i < num; i++) {
    //         circles.push(new Circle(Math.random() * w, Math.random() * h));
    //     }
    //     draw();
    // }
    // window.addEventListener('load', init2(100));
    // window.onmousemove = function (e) {
    //     e = e || window.event;
    //     current_circle.x = e.clientX;
    //     current_circle.y = e.clientY;
    // }
    // window.onmouseout = function () {
    //     current_circle.x = null;
    //     current_circle.y = null;

    // };
  }

  hanndleMessage(event) {
    const origin = event.origin;
    // console.debug("origin", event.origin);
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      const appId = process.env.REACT_APP_LOGIN_APPID;
      const REDIRECT_URL = process.env.REACT_APP_LOGIN_REDIRECT_URL;
      window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appId}&response_type=code&scope=snsapi_auth&state=STATE&redirect_uri=${REDIRECT_URL}`;
    } else if (origin === "https://login.dingtalk.com") {
      // 判断是否来自ddLogin扫码事件。
      const loginTmpCode = event.data; // 拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了
      window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${this.appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=REDIRECT_URI&loginTmpCode=${loginTmpCode}`;
    }
  }

  //获取验证码
  getCode = async () => {
    this.state.imgSrc = "";
    const res = await fetchHandler(getCode);
    if (res.code === "success") {
      this.setState({
        imgSrc: res.data.image,
        requestId: res.data.requestId,
      });
    }
  };

  //刷新验证码
  refreshCode = () => {
    this.interval = setInterval(() => {
      this.getCode();
    }, 1000 * 60);
  };

  //是否需要选择所属公司
  checkCompanyList = async () => {
    const res = await fetchHandler(getCompanyListApi);
    if (res.code === "success") {
      const companyList = res.data;
      if (companyList.length === 0) {
        // 没有公司
        message.error("您没有公司");
        return { needSelectCompany: false };
      } else if (companyList.length === 1 && AUTO_SELECT_COMPANY) {
        // 只有一个公司的时候
        const defaultCompany = companyList[0];
        window.sessionStorage.setItem("companyId", defaultCompany.id);
        window.sessionStorage.setItem("companyName", defaultCompany.name);
        // const areaList = defaultCompany.list;
        // if (areaList && Array.isArray(areaList)) {
        //   if (areaList.length > 1) {
        //     defaultArea = { id: "" };
        //   } else if (areaList.length === 1) {
        //     // 地区只有一个
        //     defaultArea = { id: "" };
        //   } else {
        //     // 地区是空数组
        //     defaultArea = { id: "" };
        //   }
        // } else {
        //   // 地区是null或其他
        //   defaultArea = { id: "" };
        // }

        const params = {
          companyId: defaultCompany.id,
          regionId: "", // 默认选择全部大区
          source: "pc",
        };
        const rres = await this.refreshToken(params);
        return rres;
      } else {
        // 多个公司
        return { needSelectCompany: true };
      }
    }
    return { needSelectCompany: false };
  };

  //刷新token
  refreshToken = async (params) => {
    const res = await fetchHandler(refreshTokenApi, params);
    console.log("refreshToken data:", res.data);
    if (res.code === "success") {
      window.sessionStorage.setItem("token", res.data.token);
      window.sessionStorage.setItem("name", res.data.userName);
      window.sessionStorage.setItem("userId", res.data.ctUserId);
      window.sessionStorage.setItem("role", res.data.role);
      window.sessionStorage.setItem("xxFlag", res.data.xxFlag);
      window.sessionStorage.setItem("userAccount", res.data.userAccount);
      window.sessionStorage.setItem("infoTypeSet", JSON.stringify(res.data.infoTypeSet));
      // console.log("login:", res.data.menuList);
      if (res.data.menuList && res.data.menuList.length > 0) {
        for (let i = 0; i < res.data.menuList.length; i++) {
          if (res.data.menuList[i].cname == "配置管理") {
            const subs = [];
            let lock = null;
            let index = -1;
            let indexs = -1;
            // 调整地锁查询到设备和电站查询下面
            for (let j = 0; j < res.data.menuList[i].childList.length; j++) {
              if (res.data.menuList[i].childList[j].cname != "地锁查询") {
                subs.push(res.data.menuList[i].childList[j]);
                if (res.data.menuList[i].childList[j].cname == "设备快速查询") {
                  index = subs.length;
                }
                if (res.data.menuList[i].childList[j].cname == "电站列表") {
                  indexs = subs.length;
                }
              } else {
                lock = res.data.menuList[i].childList[j];
              }
            }
            if (lock != null) {
              subs.splice((index = -1 ? indexs + 1 : index + 1), 0, lock);
            }
            res.data.menuList[i].childList = subs;
          }
        }
      }
      // console.log("login:", res.data.menuList);
      window.sessionStorage.setItem("menulist", JSON.stringify(res.data.menuList));
      this.setState({ loading: false });
      // 增加检查菜单权限判断
      if (Array.isArray(res.data.menuList) && res.data.menuList.length > 0) {
        message.success("登录成功");
        this.props.history.push("/index");
      } else {
        message.error("您暂无权限");
      }
    }
    return { needSelectCompany: false };
  };

  //SSO-Login
  handleSSOLogin = (info) => {
    ssoLogin({
      code: info,
      redirectUri: this.state.redirectUri,
    }).then(async (res) => {
      console.log("handleSSOLogin res:", res);
      if (String(res.data.code) === "200") {
        // console.log('zzz');
        // window.sessionStorage.setItem("userAccount", res.data.userName);
        window.sessionStorage.setItem("token", res.data.data.token);
        const { needSelectCompany } = await this.checkCompanyList();
        if (needSelectCompany) {
          this.setState({ logining: false });
          message.success("登录成功");
          this.props.history.push("/selectcompany");
        }
      } else {
        // console.log('xxx');
        message.warning(res.data.text || "单点登录失败");
        this.setState({ logining: false });
        window.sessionStorage.removeItem("sso_code");
        // this.props.history.push("/login");
      }
    });
  };

  render() {
    // const lanmenu = (
    //     <Menu>
    //         <Menu.Item>
    //             <a onClick = {()=>{this.changeLocale('zh')}}>中文</a>
    //         </Menu.Item>
    //         <Menu.Item>
    //             <a onClick = {()=>{this.changeLocale('en')}} >英文</a>
    //         </Menu.Item>
    //         <Menu.Item>
    //             <a onClick = {()=>{this.changeLocale('es')}} >西班牙语</a>
    //         </Menu.Item>
    //     </Menu>
    // );

    // const internationalization = this.props.intl.messages.newLogin;
    const LoginDom = (
      <div className="loginWrap">
        {/* <div className="loginHeader">
          <div className="companyIcon">
            <div className="companyIconItem"></div>
            <span className="fengge">|</span>
            <span className="sysName">智能运维系统</span>
          </div>

          <div className="changeLanguage">
            <div className = "location">{this.state.location}</div>

            <Dropdown overlay={lanmenu}>
               <Button
                className = "languageDropDown"
                 style = {{'zIndex' : '100'}}  href="javascript:void(0)">
                   <span className={'username'}>{this.state.language}</span>
                   <Icon type={'down'}></Icon>
               </Button>
            </Dropdown>
          </div>
        </div> */}
        <div className="loginHeaderV2">
          <div className="logo"></div>
        </div>
        <div className="login-box">
          {ShowSwitchLoginType && (
            <div className="switch-login-type">
              <div
                className={`login-type-item ${this.state.loginType === "dingding" ? "active" : ""}`}
                onClick={() => {
                  this.setState({ loginType: "dingding" });
                }}>
                钉钉扫码
              </div>
              <Divider type="vertical" style={{ height: 29 }} />
              <div
                className={`login-type-item ${this.state.loginType === "password" ? "active" : ""}`}
                onClick={() => {
                  this.setState({ loginType: "password" });
                }}>
                密码登陆
              </div>
            </div>
          )}
          {/* <div className="login-title">
                        <img src={loginLogo} className="App-logo" alt="logo"/>
                    </div> */}
          <div style={{ display: this.state.loginType === "dingding" ? "block" : "none" }}>
            <div id="login_container"></div>
          </div>
          {this.state.loginType === "password" && (
            <Spin spinning={this.state.logining}>
              <div id="password_login_container">
                <div className="title">账号登陆</div>
                <Form
                  onFinish={async (v) => {
                    this.setState({ logining: true });
                    const params = JSON.parse(JSON.stringify(v));
                    params.verifyCode = `${this.state.requestId},${params.verifyCode}`;
                    const res = await fetchHandler(loginWithPasswordApi, {
                      ...params,
                      source: "pc",
                    });
                    this.setState({ logining: false });
                    // console.log(res);
                    if (res.code === "success") {
                      clearInterval(this.interval);
                      // 存储数据，跳转页面
                      window.sessionStorage.setItem("userAccount", res.data.userName);
                      window.sessionStorage.setItem("token", res.data.token);
                      window.sessionStorage.setItem("userTel", res.data.phone);
                      window.sessionStorage.setItem("resetPwdFlag", res.data.resetPwdFlag);
                      const { needSelectCompany } = await this.checkCompanyList();
                      if (needSelectCompany) {
                        message.success("登录成功");
                        this.props.history.push("/selectcompany");
                      }
                    } else {
                      console.error(res.text);
                    }
                  }}>
                  <Form.Item
                    name="account"
                    rules={[
                      { required: true, message: "请输入账号!" },
                      //  {
                      //   pattern: /(^1[3456789]\d{9}$)|(^\w+@[a-z0-9]+\.[a-z]{2,4}$)/,
                      //   message: "请输入电话号码或者邮箱",
                      // },
                    ]}
                    normalize={(v) => v.trim()}>
                    <Input
                      placeholder="请输入账号"
                      prefix={<UserOutlined className="site-form-item-icon" />}
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[{ required: true, message: "请输入密码!" }]}
                    normalize={(v) => v.trim()}>
                    <Input
                      placeholder="请输入密码"
                      prefix={<LockOutlined className="site-form-item-icon" />}
                      type="password"
                    />
                  </Form.Item>
                  {/* 验证码 */}
                  <Row style={{ width: 350 }}>
                    <Col>
                      <Form.Item
                        name="verifyCode"
                        rules={[
                          {
                            required: true,
                            message: "请输入验证码!",
                          },
                        ]}>
                        <Input
                          style={{ width: 213, height: 50 }}
                          placeholder="请输入验证码"
                          allowClear
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}>
                      {this.state.imgSrc ? (
                        // eslint-disable-next-line jsx-a11y/alt-text
                        <img
                          className="login-form-code"
                          id="img"
                          src={
                            this.state.imgSrc ? `data:image/gif;base64,${this.state.imgSrc}` : ""
                          }
                          style={{ width: 105, height: 49, marginTop: -22, marginLeft: 10 }}
                          onClick={() => {
                            this.getCode();
                          }}
                        />
                      ) : (
                        <SyncOutlined
                          spin
                          style={{
                            marginLeft: 10,
                            marginTop: -10,
                            width: 80,
                            color: "#11B234",
                          }}
                        />
                      )}
                    </Col>
                  </Row>
                  <Form.Item>
                    <Button htmlType="submit">登录</Button>
                  </Form.Item>
                  <Form.Item>
                    <div
                      style={{
                        color: "red",
                        cursor: "pointer",
                        textAlign: "right",
                      }}
                      onClick={() => {
                        window.location.href = this.state.authUrl;
                      }}>
                      单点登录入口
                    </div>
                  </Form.Item>
                </Form>
                {/* <div className="forget-pwd">忘记密码</div> */}
              </div>
            </Spin>
          )}
          {/* <div className="bg"></div> */}
          {/* <div style={{height:150}}></div> */}
        </div>
        {/* <div className="sc-oms-footer-login" style={{ lineHeight: "20px" }}>
          COPYRIGHT &copy;2018 万帮星星充电科技有限公司 All rights reserved.
          <br />{" "}
          <a
            style={{ color: "#fff" }}
            onClick={() => {
              window.open("http://beian.miit.gov.cn/");
            }}
          >
            苏ICP备14056214号-3{" "}
          </a>{" "}
          版本号：{process.env.REACT_APP_VERSION}
        </div> */}
        <canvas className="login-bg" id="canvas"></canvas>
      </div>
    );
    return LoginDom;
  }
}

export default injectIntl(Login);



// WEBPACK FOOTER //
// ./src/AntD/pages/login.js